import { Box, LinearProgress } from "@mui/material";
import { useState } from "react";
import useInventory from "hooks/useInventory";
import useInventoryTemplates from "hooks/useInventoryTemplates";
import InventoryAddField from "./InventoryAddField";
import { defaultInventoryAdd, InventoryAddProps } from "../../types/inventory";
import { useLocation, useNavigate } from "react-router-dom";
import { StyledButton } from "./InventoryStyles";
import { InventoryTemplate } from "types/inventoryTemplate";
import URLHashParams from "utils/URLHashParams";
import { AutoPagePaperLayout } from "pages/Layouts/AutoPagePaperLayout";
import { PageBreadcrumbs, PageTitle } from "pages/Layouts/components/PageTitleContainer";
import usePickup from "hooks/usePickup";

const newTemplate: InventoryTemplate = {
  uuid: "",
  manufacturer: "",
  model: "",
  name: "",
  description: "",
  cpu: "",
  ram: "",
  hardDrive: "",
  screenSize: "",
  isBulk: false,
  deviceType: "",
};

export default function InventoriesNew() {
  const location = useLocation();
  const navigate = useNavigate();
  const { pickup } = usePickup();

  const { createInventory, isLoading } = useInventory();
  const { searchInventoryTemplates, inventoryTemplates, setInventoryTemplates } = useInventoryTemplates();
  const [inventories, setInventories] = useState<InventoryAddProps[]>([defaultInventoryAdd()]);

  const addInventory = (newInventory: InventoryAddProps) => {
    setInventories([...inventories, newInventory]);
  };

  const handleSubmit = () => {
    createInventory({
      inventories,
    });
  };

  const handleCreatedInventoryTemplate = (inventoryTemplate: InventoryTemplate) => {
    setInventoryTemplates((inventoryTemplates) => [inventoryTemplate, ...inventoryTemplates]);
    const newLocation = { ...location };
    const hash = new URLHashParams(newLocation.hash);
    hash.delete("newTemplate");
    newLocation.hash = hash.toString();
    navigate(newLocation, { replace: true });
  };

  return (
    <AutoPagePaperLayout>
      <PageBreadcrumbs
        links={[
          { label: "Warehouse" },
          { label: "Pickups", path: "/pickups" },
          { label: `Pickup ${pickup.id}`, path: `/pickups/${pickup?.id}` },
        ]}
      />
      <PageTitle>Add Pickup Inventory</PageTitle>
      {isLoading ? <LinearProgress /> : null}
      <InventoryAddField
        addInventory={addInventory}
        inventory={inventories[inventories.length - 1]}
        inventories={inventories}
        inventoryTemplates={inventoryTemplates}
        setInventories={setInventories}
        searchInventoryTemplates={searchInventoryTemplates}
      />
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <StyledButton disabled={isLoading} variant="outlined" onClick={() => navigate(-1)}>
          Back
        </StyledButton>
        <StyledButton disabled={isLoading} variant="contained" onClick={handleSubmit}>
          Save
        </StyledButton>
      </Box>
    </AutoPagePaperLayout>
  );
}
